const CLASSIC_ROLE_PRIORITY = [
  "MEA_PROCESSORS",
  "MEA_ADMIN",
  "MEA_UNDERWRITER",
  "MEA_CORPORATE",
];

export const resolveClassicUserRole = (groups) => {
  const groupList = Array.isArray(groups) ? groups : [];
  return CLASSIC_ROLE_PRIORITY.find((role) => groupList.includes(role)) || "MEA_USERS";
};

export const canOpenClassicQaTool = (role, row) =>
  Boolean(
    row &&
      (row.jsonMarkCompletePath || row.jsonExtractpath) &&
      [
        "MEA_CORPORATE",
        "MEA_UNDERWRITER",
        "MEA_ADMIN",
      ].includes(role) &&
      [
        "Complete",
        "QA In Progress",
        "QA Uploaded",
        "QA Complete",
      ].includes(row.processingStatus),
  );
